module.exports = __webpack_public_path__ + "static/img/noBody.37c3ea6b.png";